<template>
  <div class="settlement-page p-6 bg-gray-100 min-h-screen">
    <div class="bg-white p-4 rounded-lg shadow-md mb-4">
      <h3 class="text-lg font-semibold text-gray-800">Жолоочийн тооцоо нийлэх хүсэлтүүд</h3>
    </div>
    <div class="bg-white p-4 rounded-lg shadow-md" v-loading="settlementLoading">
      <div>
        <el-form
          :model="date"
          ref="date"
          label-position="top"
          :inline="true"
          size="mini"
        >
          <el-form-item label="Жолоочийн нэр" prop="driver_name">
            <el-select
              @change="changeDriver(driver_id)"
              filterable
              placeholder="Жолоочийн нэр"
              clearable
              v-model="driver_id"
              :disabled="disabledDriver"
            >
              <el-option
                v-for="item in allDriverList"
                :key="item.firebase_uid"
                :label="item.name"
                :value="item.firebase_uid"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="start_date" label="Эхлэх огноо">
            <el-date-picker
              @change="currentPage = 1"
              v-model="date.start_date"
              type="date"
              placeholder="Эхлэх огноо"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="end_date" label="Дуусах огноо">
            <el-date-picker
              @change="currentPage = 1"
              v-model="date.end_date"
              type="date"
              placeholder="Дуусах огноо"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions2"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Төлөв">
            <el-select clearable v-model="status_code" @change="currentPage = 1" placeholder="Сонгох">
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Даймонд бичилт">
            <el-select filterable placeholder="Сонгоно уу" @change="currentPage = 1" v-model="is_diamond">
              <el-option
                v-for="item in diamond_array"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Регистр">
            <el-input :disabled="disableRegister" @input="changeRegister(register_number)" v-model="register_number" placeholder="Регистрийн дугаар"></el-input>
          </el-form-item>
          <el-form-item :label="whitespace">
            <el-button
              type="primary"
              @click="getSettlement()"
              icon="el-icon-search"
              >Хайх
            </el-button>
            <el-button
              style="background-color: #1d6f42; color: #fff"
              size="mini"
              :loading="excelLoading"
              icon="el-icon-download"
              @click="onexport()"
              align="right"
              plain
              >Татаж (.xlsx)</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table
        v-if="settlementData"
        empty-text="Өгөгдөл байхгүй байна."
        :data="settlementData"
        :row-key="row => row.id"
        :expand-row-keys="expandedKeys"
        @expand-change="handleExpandChange"
        style="width: 100%"
        size="mini"
      >
        <el-table-column
          type="expand"
          width="80px"
        >
          <template>
            <el-table
              :data="days"
              style="width: 100%"
              empty-text="Өгөгдөл байхгүй байна."
              :show-header="false"
              v-loading="expandedLoading"
              @row-click="showDayDetail"
            >
              <el-table-column width="95px">
                <template slot-scope="prop">
                  {{ formatDate(prop.row.date, "MM/DD") }}
                </template>
              </el-table-column>
              <el-table-column
                width="77px"
                prop="order_count"
              ></el-table-column>
              <el-table-column width="80px">
                <template slot-scope="prop">
                  {{ prop.row.kilometer }} км
                </template>
              </el-table-column>
              <el-table-column width="100px">
                <template slot-scope="prop">
                  {{ formatPrice(prop.row.salary) }}₮
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="id" width="100px"></el-table-column> -->
        <el-table-column
          prop="driver_name"
          label="Жолоочийн нэр"
          width="150"
        >
          <template slot-scope="scope">
            <p style="overflow-wrap: normal; word-break: normal;">{{ scope.row.driver_name }}</p>
          </template>
        </el-table-column>
        <el-table-column label="Огноо" width="100">
          <template slot-scope="prop">
            {{ formatDate(prop.row.start_date, "MM/DD") }} -
            {{ formatDate(prop.row.end_date, "MM/DD") }}
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="Захиалга"
          prop="order_count"
        ></el-table-column>
        <el-table-column width="80" label="Явсан км">
          <template slot-scope="prop">
            {{ prop.row.kilometer }} км
          </template>
        </el-table-column>
        <el-table-column width="120" label="Үндсэн ү/төлбөр">
          <template slot-scope="prop">
            {{ formatPrice(parseFloat(prop.row.salary) + parseFloat(prop.row.rush_hour_additional)) }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" label="Км нэмэлт">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.km_additional) }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" label="Цуглуулалт/төлбөр">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.collection_salary) }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" label="Хуваарьт ажилласан/төлбөр">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.worked_on_schedule_addition) }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" label="Амжсан цагтаа/төлбөр">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.kpi_additional) }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" label="Их Их/төлбөр">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.tr_additional) }}₮
          </template>
        </el-table-column>
        <el-table-column width="100" label="Гал Гал 🔥">
          <template slot-scope="prop">
            {{formatPrice( prop.row.planned_additional )}}₮
          </template>
        </el-table-column>
        <el-table-column width="100" label="Ас Ас 💥">
          <template slot-scope="prop">
            {{formatPrice( prop.row.on_time_additional )}}₮
          </template>
        </el-table-column>
        <el-table-column width="180px" label="Банкны нэр">
          <template slot-scope="prop">
            <el-input v-if="banks.length > 0" :value="banks.find(el => el.bank_code == prop.row.bank_code) ? banks.find(el => el.bank_code == prop.row.bank_code).bank_name_mon : prop.row.bank_code" disabled placeholder="Банкны нэр" size="mini">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column width="100" label="Регистр">
          <template slot-scope="prop">
            {{ prop.row.register_number }}
          </template>
        </el-table-column>
        <el-table-column width="200" label="Дансны нэр">
          <template slot-scope="prop">
            {{ prop.row.bank_account_name }}
          </template>
        </el-table-column>
        <el-table-column width="120" label="Дансны дугаар">
          <template slot-scope="prop">
            {{ prop.row.bank_account_number }}
          </template>
        </el-table-column>
        <el-table-column width="100" label="Олгох төлбөр">
          <template slot-scope="prop">
            {{formatPrice( prop.row.all_salary )}}₮
          </template>
        </el-table-column>
        <el-table-column width="110" label="Төлөв">
          <template slot-scope="prop">
            <el-tag
              size="mini"
              class="mr10"
              type="success"
              v-if="prop.row.status_code === 100"
              >{{prop.row.status}}</el-tag
            >
            <el-tag
              size="mini"
              class="mr10"
              type="danger"
              v-else-if="prop.row.status === 'Амжилтгүй'"
              >{{prop.row.status}}</el-tag
            >
            <el-tag
              size="mini"
              class="mr10"
              v-else-if="prop.row.status === 'Үүссэн'"
              >{{prop.row.status}}</el-tag
            >
            <el-tag
              size="mini"
              class="mr10"
              type="danger"
              v-else-if="prop.row.status === 'Зөрүүтэй'"
              >{{prop.row.status}}</el-tag
            >
            <el-tag
              size="mini"
              class="mr10"
              type="warning"
              v-else-if="prop.row.status_code === 99"
              >{{prop.row.status}}</el-tag
            >
            <el-tag
              size="mini"
              class="mr10"
              type="info"
              v-else
              >{{prop.row.status}}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column width="80" label="Д/бичилт">
          <template slot-scope="scope">
            <el-switch
              :disabled="isDisable"
              @change="changeDiamond(scope.row, scope.$index)"
              v-model="scope.row.is_diamond_sent"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
            ></el-switch>
            <!-- <el-checkbox v-model="prop.row.is_diamond_sent" v-if="!prop.row.zoruu_salary" @change="changeDiamond(prop.row)"></el-checkbox> -->
          </template>
        </el-table-column>
        <el-table-column width="120" label="Е-баримт суутгал">
          <template slot-scope="prop">
            <el-tag
              v-if="prop.row.settlement_create_deduction != null && prop.row.settlement_create_deduction > 0"
              size="small"
              type="danger"
              >{{ formatPrice(prop.row.settlement_create_deduction) }}₮</el-tag
            >
          </template>
        </el-table-column>
        <!-- v-if="!scope.row.zoruu_salary" -->
        <el-table-column width="120" label="Зөрүү">
          <template slot-scope="prop">
            <el-tag
              v-if="prop.row.zoruu_salary != null && prop.row.zoruu_salary > 0"
              size="small"
              type="danger"
              >{{ formatPrice(prop.row.zoruu_salary) }}₮</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column width="150" label="Төлбөр буусан огноо">
          <template slot-scope="prop">
            <span>{{ prop.row.sent_date !== "null" ? prop.row.sent_date : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="300px" label="Тайлбар/зөрүү/">
          <template slot-scope="prop">
            <!-- <el-tag
              v-if="prop.row.zoruu_note != 'null' && prop.row.zoruu_note != ''"
              size="small"
              type="info"
              style="width: 300px;"
              >{{ prop.row.zoruu_note }}</el-tag
            > -->
            <el-input type="textarea" size="mini" v-if="prop.row.zoruu_note != 'null' && prop.row.zoruu_note != ''" disabled v-model="prop.row.zoruu_note"></el-input>
          </template>
        </el-table-column>
        <el-table-column width="120" label="Нэмэлт">
          <template slot-scope="prop">
            <el-tag
              v-if="prop.row.additional_amount != null && prop.row.additional_amount > 0"
              size="small"
              type="success"
              >{{ formatPrice(prop.row.additional_amount) }}₮</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column width="250" label="Тайлбар/нэмэлт/">
          <template slot-scope="prop">
            <!-- <el-tag
              v-if="prop.row.additional_note != 'null' && prop.row.additional_note != ''"
              size="small"
              type="info"
              >{{ prop.row.additional_note }}</el-tag
            > -->
            <el-input size="mini" v-if="prop.row.additional_note != 'null' && prop.row.additional_note != ''" type="textarea" disabled v-model="prop.row.additional_note"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Үйлдэл"> -->
        <el-table-column fixed="right" width="90" label="Үйлдэл">
          <template slot-scope="prop">
            <div style="float:right" v-if="![90, 100].includes(prop.row.status_code)">
              <el-tooltip content="Зөрүү тэмдэглэх" placement="top">
                <i class="el-icon-edit-outline"
                  style="font-size: 2rem; color: #FE4B4B;"
                  @click="addDifference(prop.row)">
                </i>
              </el-tooltip>
            </div>
            <div style="float:left" v-if="![90, 100].includes(prop.row.status_code)">
              <el-tooltip content="Нэмэлт ү/төлбөр" placement="top">
                <i class="el-icon-circle-plus-outline" size="mini"
                  style="font-size: 2rem;"
                  @click="addSalary(prop.row)">
                </i>
              </el-tooltip>
            </div>
            <div style="float:left" v-if="prop.row.status_code === 90">
              <el-tooltip content="Нөхөн шилжүүлэг" placement="top">
                <i class="el-icon-refresh" size="mini"
                  style="font-size: 2rem; color: #6CDF7A;"
                  @click="reimbursementFunc(prop.row)"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="180px">
          <template slot-scope="scope">
            <el-button
              type="success"
              :disabled="scope.row.status_code !== 100"
              v-model="scope.row.id"
              active-color="#13ce66"
              @click="emailRecovery(scope.row.id)"
            >Мэйл нөхөж авах</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="text-right mt10"
        background
        layout="total, prev, pager, next"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        :total="totalCount"
        :page-size="pageSize"
        @current-change="setPage"
      >
      </el-pagination>
    </div>
    <driverDetailLog
      v-if="driverDetailDialogVisible"
      :isShow="driverDetailDialogVisible"
      :closeDialogDetail="closeDialogDetail"
      :close="closeDialogDetail"
      :formatDate="formatDate"
      :formatPrice="formatPrice"
      :currentDetail="currentDetail"
      :driverUid="detailDriverUid"
    ></driverDetailLog>
    <isZoruu
      v-if="zoruuDialogVisible"
      :isDisabled="saveButtonDisabled"
      :isShow="zoruuDialogVisible"
      :closeFunction="closeFunction"
      :close="closeFunction"
      :updateValue="updateValue"
      :formatDate="formatDate"
      :currentZoruu="currentZoruu"
      :saveDifference="saveDifference"
    ></isZoruu>
    <additionalSalary
      v-if="additionDialogVisible"
      :isShow="additionDialogVisible"
      :closeAdditional="closeAdditional"
      :close="closeAdditional"
      :currentAdditionSalary="currentAdditionSalary"
      :saveAdditional="saveAdditional"
      :formatPrice="formatPrice"
      :settlementLoading="settlementLoading"
    >
    </additionalSalary>
    <el-dialog
      v-if="reimbursement"
      :title="'Та нөхөн шилжүүлсэн төлөвт шилжүүлэх гэж байна!'"
      :visible.sync="reimbursementDialogVisible"
      width="500px"
      style="align-items: center"
    >
      <div slot="footer">
        <el-button @click="reimbursementDialogVisible = false">Үгүй</el-button>
        <el-button type="primary" @click="confirmReimbursement">Тийм</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import additionalSalary from './components/driverSettlementDialogs/additionalDialog.vue'
import driverDetailLog from './components/driverSettlementDialogs/driverDetailLog.vue'
import isZoruu from './components/driverSettlementDialogs/settlementDialog.vue'
import services from '@/helpers/partnerServices.js'
import helper from '../../helpers/helper'
import XLSX from 'xlsx'
import { getGroups } from '@/utils/auth.js'
export default {
  name: 'SettlementListDriver',
  components: {
    isZoruu,
    driverDetailLog,
    additionalSalary
  },
  data () {
    return {
      saveButtonDisabled: false,
      expandedLoading: false,
      detailDriverUid: '',
      days: [],
      expandedKeys: [],
      excelLoading: false,
      driverDetailDialogVisible: false,
      settlementLoading: false,
      settlementData: null,
      settlementDialogVisible: false,
      zoruuDialogVisible: false,
      additionDialogVisible: false,
      differenceLoading: false,
      driver_id: null,
      currentDetail: null,
      current: null,
      currentZoruu: null,
      isCurrentZoruu: null,
      currentAdditionSalary: null,
      status_code: '',
      whitespace: '\xa0',
      currentPage: 1,
      pageCount: null,
      totalCount: null,
      pageSize: null,
      page: 0,
      allDriverList: [],
      is_diamond: null,
      reimbursement: null,
      reimbursementDialogVisible: false,
      reimbursementStatusCode: null,
      diamond_array: [
        {
          label: 'Бичилт хийгдсэн',
          value: 1
        },
        {
          label: 'Бичилт хийгдээгүй',
          value: 0
        },
        {
          label: 'Бүгд',
          value: null
        }
      ],
      status: [
        {
          value: 10,
          label: 'Үүссэн'
        },
        {
          value: 90,
          label: 'Амжилтгүй'
        },
        {
          value: 91,
          label: 'Зөрүүтэй'
        },
        {
          value: 99,
          label: 'Нөхөн шилжүүлсэн'
        },
        {
          value: 100,
          label: 'Амжилттай'
        }
      ],
      balance_note: null,
      settlement_id: 0,
      diffreence: [],
      date: {
        start_date: null,
        end_date: null
      },
      pickerOptions1: {
        firstDayOfWeek: 1,
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      pickerOptions2: {
        firstDayOfWeek: 1,
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      loadUpload: false,
      name: 'xoxo',
      selectedSettlement: JSON.parse(
        window.localStorage.getItem('settlementSelectData')
      ),
      confirmButtonType: true,
      banks: [],
      item: null,
      register_number: null,
      disableRegister: false,
      disabledDriver: false,
      isDisable: false,
      groups: []
    }
  },
  created () {
    this.getDriverNames()
    this.getSettlement()
  },
  mounted () {
    this.getBankCodes()
  },
  methods: {
    handleExpandChange (row, expanded) {
      this.detailDriverUid = row.driver_uid
      row && this.expandedKeys.includes(row.id) ? this.expandedKeys = this.expandedKeys.filter(key => key !== row.id) : this.expandedKeys = [row.id]
      if (expanded.length > 0) {
        this.expandedLoading = true
        const payload = {
          driver_uid: row.driver_uid,
          start_date: row.start_date,
          end_date: row.end_date
        }
        services.getDSettlementsDayData(payload).then((response) => {
          if (response.status === 'success') {
            this.days = response.data
            this.expandedLoading = false
          } else {
            this.days = []
            this.expandedLoading = false
          }
        })
      }
    },
    reimbursementFunc (pay, statusCode) {
      this.reimbursement = Object.assign({}, pay)
      this.reimbursementStatusCode = statusCode
      this.reimbursementDialogVisible = true
    },
    confirmReimbursement () {
      try {
        services
          .changeSettlementStatusDriver({
            settlement_id: this.reimbursement.settlement_id,
            settlement_status: 90
          })
          .then((response) => {
            if (response.data.status === 'success') {
              this.$notify.success({
                title: 'Амжилттай',
                position: 'bottom-left',
                message: ' Амжилттай',
                duration: 2000
              })
              this.reimbursementDialogVisible = false
            } else {
              this.$notify.error({
                title: 'Уучлаарай',
                position: 'bottom-left',
                message: response.data.message,
                duration: 2000
              })
            }
          }).catch((error) => {
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: error.message,
              duration: 2000
            })
          })
      } catch (error) {
        this.$store.commit('pushError', {
          type: 'warning',
          title: 'Уучлаарай',
          message: error.message,
          description: 'Алдаа гарлаа'
        })
      }
    },
    closeDropdown () {
      this.$store.dispatch('contextmenu/DEACTIVATE_CONTEXTMENU')
    },
    getDriverNames () {
      try {
        services.getDriverNames().then((response) => {
          console.log('response', response)
          if (response.status === 'success') {
            this.allDriverList = response.data
          } else {
            this.$notify({
              title: 'Амжилтгүй',
              message: response.error.message,
              type: 'error'
            })
          }
        })
      } catch {
        this.$store.commit('pushError', {
          type: 'warning',
          title: 'Уучлаарай',
          description: 'Алдаа гарлаа'
        })
      }
    },
    closeFunction () {
      this.zoruuDialogVisible = false
      this.currentZoruu = null
    },
    closeDialogDetail () {
      this.driverDetailDialogVisible = false
      this.currentDetail = null
    },
    closeAdditional () {
      this.additionDialogVisible = false
      this.currentAdditionSalary = null
    },
    updateValue (event, id) {
      if (event > (this.currentZoruu.salary - this.currentZoruu.settlement_create_deduction)) {
        this.currentZoruu.zoruu_salary = event
      }
    },
    formatDate (date, format) {
      return helper.formatDate(date, format)
    },
    formatPrice (price) {
      return parseFloat(price).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    addDifference (value) {
      this.currentZoruu = Object.assign({}, value)
      this.zoruuDialogVisible = true
    },
    addSalary (value) {
      this.currentAdditionSalary = Object.assign({}, value)
      this.additionDialogVisible = true
    },
    showDayDetail (row) {
      this.currentDetail = Object.assign({}, row)
      this.driverDetailDialogVisible = true
    },
    setPage (val) {
      this.currentPage = val
      this.getSettlement()
    },
    async getBankCodes () {
      try {
        const { data: axiosRes } = await axios
          .get(process.env.VUE_APP_MANAGE_API + '/dsettlement/getBankCodes')
        console.log('axiosRes', axiosRes)
        if (axiosRes.status === 'success') {
          this.banks = axiosRes.data
        } else {
          self.$notify({
            title: 'Амжилтгүй',
            message: axiosRes.error,
            type: 'warning'
          })
        }
      } catch (error) {
        self.$notify.error({
          title: 'Уучлаарай',
          position: 'bottom-left',
          message: error.message,
          duration: 2000
        })
      }
    },
    async getSettlement () {
      this.group = await getGroups()
      if (this.group.includes('view')) this.isDisable = true
      const isValidStartDate = this.date.start_date !== null
      const isValidEndDate = this.date.end_date !== null
      if (isValidStartDate && isValidEndDate) {
        if (this.date.start_date > this.date.end_date) {
          this.$notify({
            title: 'Анхааруулга',
            message: 'Сонгосон хугацаагаар хайх боломжгүй байна',
            type: 'error'
          })
          return false
        }
      } else if (
        (isValidStartDate && !isValidEndDate) ||
          (isValidEndDate && !isValidStartDate)
      ) {
        this.$notify({
          title: 'Анхааруулга',
          message: 'Эхлэх болон дуусах хугацааг сонгоно уу',
          type: 'error'
        })
        return false
      }
      try {
        let payload = {}
        if (!['', null, 'null', undefined].includes(this.register_number)) {
          payload = {
            is_diamond_sent: this.is_diamond,
            current_page: this.pageSize,
            page: this.currentPage,
            start_date: this.date.start_date,
            end_date: this.date.end_date,
            status_code: this.status_code,
            register_number: this.register_number
          }
        } else {
          payload = {
            is_diamond_sent: this.is_diamond,
            current_page: this.pageSize,
            page: this.currentPage,
            start_date: this.date.start_date,
            end_date: this.date.end_date,
            status_code: this.status_code
          }
        }
        if (!['', null, 'null', undefined].includes(this.driver_id)) {
          payload.driver_uid = this.driver_id
        }
        this.settlementLoading = true
        services.getDSettlementsNew(payload).then((response) => {
          console.log('response', response)
          if (response.status === 'success') {
            this.settlementData = response.data.data
            this.totalCount = response.data.total
          } else {
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: response.error.message,
              duration: 2000
            })
          }
          this.settlementLoading = false
        })
          .catch((error) => {
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: error.message,
              duration: 2000
            })
          })
      } catch {
        this.$store.commit('pushError', {
          type: 'warning',
          title: 'Уучлаарай',
          description: 'Алдаа гарлаа'
        })
      }
    },
    changeDiamond (value, index) {
      try {
        services
          .changeSettlementStatusDriver({
            settlement_id: value.settlement_id,
            settlement_status: 50,
            is_diamond_sent: value.is_diamond_sent
          })
          .then((response) => {
            if (response.data.status === 'success') {
              this.settlementData[index].is_diamond_sent = value.is_diamond_sent
              this.$notify.success({
                title: 'Амжилттай',
                position: 'bottom-left',
                message: ' Амжилттай',
                duration: 2000
              })
              this.zoruuDialogVisible = false
            } else {
              this.$notify.error({
                title: 'Уучлаарай',
                position: 'bottom-left',
                message: response.data.message,
                duration: 2000
              })
              this.differenceLoading = true
              this.settlementData[index].is_diamond_sent =
                !value.is_diamond_sent
            }
          }).catch((error) => {
            const tempVal = value.is_diamond_sent ? 0 : 1
            this.settlementData[index].is_diamond_sent = tempVal
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: error.message,
              duration: 2000
            })
          })
      } catch (error) {
        this.$store.commit('pushError', {
          type: 'warning',
          title: 'Уучлаарай',
          message: error.message,
          description: 'Алдаа гарлаа'
        })
      }
    },
    saveAdditional () {
      try {
        services
          .changeSettlementStatusDriver({
            settlement_id: parseInt(this.currentAdditionSalary.settlement_id),
            settlement_status: 31,
            settlement_note: this.currentAdditionSalary.additional_note,
            settlement_additional: this.currentAdditionSalary.additional_amount
          })
          .then((response) => {
            if (response.data.status === 'success') {
              this.$notify.success({
                title: 'Амжилттай',
                position: 'bottom-left',
                message: ' Амжилттай',
                duration: 2000
              })
              this.additionDialogVisible = false
              this.getSettlement()
            } else {
              this.$notify.error({
                title: 'Уучлаарай',
                position: 'bottom-left',
                message: response.data.message,
                duration: 2000
              })
            }
          })
          .catch((error) => {
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: error.message,
              duration: 2000
            })
          })
      } catch {
        this.$store.commit('pushError', {
          type: 'warning',
          title: 'Уучлаарай',
          description: 'Алдаа гарлаа'
        })
      }
    },
    saveDifference () {
      try {
        this.saveButtonDisabled = true
        services
          .changeSettlementStatusDriver({
            settlement_id: parseInt(this.currentZoruu.settlement_id),
            settlement_status: 21,
            settlement_note: this.currentZoruu.zoruu_note,
            settlement_zoruu: this.currentZoruu.zoruu_salary,
            is_zoruu_full_amount: this.currentZoruu.is_zoruu_full_amount,
            is_withdraw_salary: this.currentZoruu.is_withdraw_salary ? this.currentZoruu.is_withdraw_salary : false
          })
          .then((response) => {
            if (response.data.status === 'success') {
              this.saveButtonDisabled = false
              this.$notify.success({
                title: 'Амжилттай',
                position: 'bottom-left',
                message: ' Амжилттай',
                duration: 2000
              })
              this.zoruuDialogVisible = false
              this.getSettlement()
            } else {
              this.saveButtonDisabled = false
              this.$notify.error({
                title: 'Уучлаарай',
                position: 'bottom-left',
                message: response.data.message,
                duration: 2000
              })
            }
          })
          .catch((error) => {
            this.saveButtonDisabled = false
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: error.message,
              duration: 2000
            })
          })
      } catch {
        this.$store.commit('pushError', {
          type: 'warning',
          title: 'Уучлаарай',
          description: 'Алдаа гарлаа'
        })
      }
    },
    onexport () {
      this.excelLoading = true
      const payload = {
        is_diamond_sent: this.is_diamond,
        current_page: this.pageSize,
        page: this.currentPage,
        start_date: this.date.start_date,
        end_date: this.date.end_date,
        status_code: this.status_code
      }
      if (!['', null, 'null'].includes(this.driver_id)) {
        payload.driver_uid = this.driver_id
      }
      services.postDriverDownloadSettLement(payload).then(res => {
        if (res.data) {
          const reportXlsx = XLSX.utils.json_to_sheet(res.data)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, reportXlsx, 'DriverSettlement')
          const currentdate = new Date()
          const datetime = currentdate.getFullYear() + '_' + currentdate.getDate() + '_' + (currentdate.getMonth() + 1) + ' ' + currentdate.getHours() + '_' + currentdate.getMinutes() + '_' + currentdate.getSeconds()
          XLSX.writeFile(wb, 'driverSettlement' + datetime + '.xlsx')
          this.excelLoading = false
        } else {
          this.$notify.error({
            title: 'Error',
            message: ('Алдаа', res.data.error.message),
            type: 'warning'
          })
          this.excelLoading = false
        }
      })
    },
    changeDriver (driver) {
      this.currentPage = 1
      if (!['', null, 'null', undefined].includes(driver)) {
        this.disableRegister = true
      } else {
        this.disableRegister = false
      }
    },
    changeRegister (registerNumber) {
      this.currentPage = 1
      if (!['', null, 'null', undefined].includes(registerNumber)) {
        this.disabledDriver = true
      } else {
        this.disabledDriver = false
      }
    },
    async emailRecovery (settlementId) {
      await axios.get(`${process.env.VUE_APP_MANAGE_API}/dsettlement/driverSalaryEmailRecover?id=${settlementId}`
      )
        .then(response => {
          if (response.data.status === 'success') {
            this.$notify.success({
              title: 'Амжилттай',
              position: 'bottom-left',
              message: ' Амжилттай',
              duration: 2000
            })
            this.loading = false
          } else {
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: response.data.message,
              duration: 2000
            })
            this.loading = false
          }
        })
        .catch(error => {
          this.$notify.error({
            title: 'Уучлаарай',
            position: 'bottom-left',
            message: error.message,
            duration: 2000
          })
          this.loading = false
        })
    }
  }
}
</script>
